import { Component, Vue } from 'vue-property-decorator'
import CAJG1110Service from './CAJG1110Service'
import CAJG1110ViewModel from './CAJG1110ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import CommonConstants from '@/common/CommonConstants'
import OtherUrlConstants from '@/common/OtherUrlConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import { DigitalBookButton } from '@/common/utils/modules-util'
import ColorBox from '@/assets/js/components/colorbox.js'
@Component({
  name: 'CAJG1110',
  components: {}
  })
export default class CAJG1110Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private OtherUrlConstants = OtherUrlConstants
  private cajg1110ViewModel: CAJG1110ViewModel = {
    studyTopBackHtmlInfo: {
      content: ''
    },
    batchDispDiv: ''
  }

  private cajg1110Service: CAJG1110Service = new CAJG1110Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContentNoLogin()
    await this.init()
    this.$nextTick(() => {
      ColorBox()
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const caja1110ResponseModel = await this.cajg1110Service.callAPICAJA1110()
    if (CommonUtil.isNotEmpty(caja1110ResponseModel.studyTopBackHtmlInfo)) {
      this.cajg1110ViewModel.studyTopBackHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caja1110ResponseModel.studyTopBackHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1110ResponseModel.studyTopBackHtmlInfo.path
        )
    } else {
      this.cajg1110ViewModel.studyTopBackHtmlInfo = null
    }
    this.cajg1110ViewModel.batchDispDiv = caja1110ResponseModel.batchDispDiv
  }

  /**
   * マーケット情報リンク押下
   */
  private gotoCAJG1090() {
    this.$router.push({ name: 'cajg1090BeforLogin' })
  }

  /**
   * わらしべ瓦版リンク押下
   */
  private gotoWarashibeTilePalte() {
    window.open(
      OtherUrlConstants.WARASHIBE_FINANCIAL_HEALTH_WEB_MAGAZINE,
      '_blank'
    )
  }

  /**
   * NTTデータ・エービック社の外部シミュレーション（外部サイト）画面に遷移する。
   */
  private gotoExternalSimulation(url: string) {
    window.open(url, '_blank')
  }

  /**
   * ログインに戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
